/* eslint-disable import/prefer-default-export */
import { createSelector } from 'reselect';
import {
  isPriceAsendingRule,
  isPriceDescendingRule,
  sortByPriceAscending,
  sortByPriceDescending,
} from '../helpers/sortHelpers';


const getSearchResults = state => (state.searchResults.results);
const getRefinements = state => (state.searchResults.refinements);
const getInitialFilters = state => (state.searchResults.selectedFilters);

export const sortSearchResults = createSelector(
  [getSearchResults],
  (results) => {
    const { productIds } = results;
    const sortRule = results.productSort.ruleId;

    if (isPriceAsendingRule(sortRule)) {
      return {
        ...results,
        productIds: sortByPriceAscending(productIds),
      };
    }

    if (isPriceDescendingRule(sortRule)) {
      return {
        ...results,
        productIds: sortByPriceDescending(productIds),
      };
    }

    return results;
  },
);

// TODO: remove when design supports resetting all filters on a refinement only search landing page
// if user relaxes all search refinements, it will result in an empty page
// the empty page at this time has no value to the customer
export const refinements = createSelector(
  [getRefinements, getInitialFilters],
  (refinements, initialFilters) => {
    if (initialFilters.length === 0) {
      return refinements;
    }

    const filteredRefinements = [];

    const includeRefinement = value => initialFilters.findIndex(
      filter => filter.id === value.id && filter.displayValue === value.displayValue,
    ) === -1;

    refinements.forEach((refinement) => {
      const values = refinement.values.filter((value) => {
        if (!value.selected) {
          return true;
        }

        return includeRefinement(value);
      });

      if (values.length === 0) {
        return;
      }

      filteredRefinements.push({
        ...refinement,
        values,
      });
    });

    return filteredRefinements;
  },
);
